// src/pages/legal/TermsPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import TextPage, { Contact, operatorName } from './TextPage';

function TermsPage() {
    return (
        <TextPage title="Terms of use" updated="25 September 2026">
            <p>
                By using Tournamental you agree to these terms. They are short on purpose. How your data is handled is
                explained in the <Link to="/privacy">privacy policy</Link>.
            </p>

            <h2>The service</h2>
            <p>
                Tournamental helps you organize and run tournaments: players, rounds, scores and rankings, with sharing,
                co-organizers and offline use. It is run by {operatorName()}, who can be reached at <Contact />.
            </p>

            <h2>Your account</h2>
            <p>
                You are responsible for your account and for what happens with it. Keep your sign-in details to yourself. You can
                delete your account at any time in the app.
            </p>

            <h2>What you enter</h2>
            <p>
                Your tournaments and everything in them stay yours. You allow us to store and process them to run the service
                for you. If you enter other people&rsquo;s names, you must be entitled to do so and should tell them. Do not
                use the app for anything unlawful, to harass others, to store content you have no right to, or to disturb or
                overload the service.
            </p>

            <h2>Co-organizers and shared links</h2>
            <p>
                If you invite co-organizers, they can change the tournament as described in the app; you are responsible for
                whom you invite. A read-only link shows the tournament to everybody who has it until you stop sharing.
            </p>

            <h2>No guarantees</h2>
            <p>
                The service is provided as it is. We take care of it and make backups, but we do not promise it is always
                available or free of errors, and backups are not a guarantee against losing data. Keep a copy (the export
                button) of what matters. To the extent the law allows, we are not liable for indirect losses, or for losses
                beyond what you paid us (which is nothing), except where the law does not allow limiting liability.
            </p>

            <h2>Ending it</h2>
            <p>
                You can stop any time and delete your account. We may suspend or remove accounts that break these terms or
                endanger the service, and we may change or end the service; we will try to give notice and time to export your
                data.
            </p>

            <h2>Changes and law</h2>
            <p>
                We may update these terms; the date above changes, and using the app after that means you accept them. Mandatory
                consumer protection rules of your country stay unaffected; otherwise the law of the operator&rsquo;s country
                applies.
            </p>
        </TextPage>
    );
}

export default TermsPage;
